import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import TypesTags from "./TypesTags";
import FillModal from "./FillModal";
const TableLoader = () => (
  <ContentLoader
    height={200}
    width={400}
    speed={2}
    primaryColor={"#f3f3f3"}
    secondaryColor={"#ecebeb"}
  >
    <rect
      x="101"
      y="16.05"
      rx="5"
      ry="5"
      width="220"
      height="16.299999999999997"
    />
    <rect x="101" y="50" rx="5" ry="5" width="220" height="10" />
    <rect x="101" y="74" rx="5" ry="5" width="220" height="10" />
    <rect x="100" y="100" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
);

class EditTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: "", isFillModalOpen: false };
  }

  generateHours = () => {
    const base = this.props.getDoctorOptionsQuery.allOptionses[0].baseDuration;
    const start = this.props.getDoctorOptionsQuery.allOptionses[0].minTimeAdmin;
    const finish = this.props.getDoctorOptionsQuery.allOptionses[0]
      .maxTimeAdmin;
    const slotTypes = this.props.allSlotTypesQuery.allSlotTypes;

    const dayTemplate = this.props.getDayTemplate.DayTemplate;
    let lines = [];
    for (var i = start; i < finish; i++) {
      let hour = i + ":00";
      let line = (
        <div key={"div" + hour} className="hour-select">
          <span>{hour}</span>
          <TypesTags
            allSlotTypes={slotTypes}
            dayTemplate={dayTemplate}
            hour={hour}
          />
        </div>
      );
      lines.push(line);
      let baseCounter = base;
      while (baseCounter < 60) {
        hour = i + ":" + baseCounter;
        line = (
          <div key={"div" + hour} className="hour-select">
            <span>{hour}</span>
            <TypesTags
              allSlotTypes={slotTypes}
              dayTemplate={dayTemplate}
              hour={hour}
            />
          </div>
        );
        lines.push(line);
        baseCounter += base;
      }
    }
    return lines;
  };
  toggleFillModal = deleted => {
    this.setState({ isFillModalOpen: !this.state.isFillModalOpen });
    this.props.getDayTemplate.refetch();
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.getDayTemplate.loading) {
      //nextProps.setSelectedOption(nextProps.getDayTemplate.DayTemplate);
      return { name: nextProps.getDayTemplate.DayTemplate.name };
    }
    return prevState;
  } /*
  componentWillReceiveProps(newProps) {
    if (!newProps.getDayTemplate.loading) {
      if (newProps.getDayTemplate.DayTemplate !== null) {
        this.setState({ name: newProps.getDayTemplate.DayTemplate.name });
        this.props.setSelectedOption(newProps.getDayTemplate.DayTemplate);
      } else {
        this.props.setSelectedOption("");
      }
    }
  }*/
  render() {
    if (
      this.props.getDayTemplate.loading ||
      this.props.getDoctorOptionsQuery.loading
    ) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="columns is-centered">
            <div className="column is-4">
              <a onClick={this.toggleFillModal}>modifier {this.state.name}</a>
            </div>
          </div>

          {this.generateHours()}

          <FillModal
            isModalOpen={this.state.isFillModalOpen}
            //  doctorId={this.props.doctorId}
            base={this.props.getDoctorOptionsQuery.allOptionses[0].baseDuration}
            minTimeAdmin={
              this.props.getDoctorOptionsQuery.allOptionses[0].minTimeAdmin
            }
            maxTimeAdmin={
              this.props.getDoctorOptionsQuery.allOptionses[0].maxTimeAdmin
            }
            slotTypes={this.props.allSlotTypesQuery.allSlotTypes}
            toggleModal={this.toggleFillModal}
            setSelectedOption={this.props.setSelectedOption}
            refetchTemplate={this.props.getDayTemplate.refetch}
            dayTemplate={this.props.getDayTemplate.DayTemplate}
            refetchTemplates={this.props.refetchTemplates}
          />
        </div>
      );
    }
  }
}
const GET_DAYTEMPLATE_QUERY = gql`
  query GetDayTemplateQuery($templateId: ID!) {
    DayTemplate(id: $templateId) {
      id
      name
      hours {
        id
        time
        slotTypes {
          name
          id
        }
      }
    }
  }
`;
const ALL_SLOTTYPES_QUERY = gql`
  query AllSlotTypesQuery($doctorId: ID!) {
    allSlotTypes(
      filter: { AND: [{ doctor: { id: $doctorId } }, { role_not: HIDDEN }] }
      orderBy: index_ASC
    ) {
      id
      name
      duration
      role
      infos
    }
  }
`;

const GET_DOCTOR_OPTIONS_QUERY = gql`
  query GetDoctorOptionsQuery($doctorId: ID!) {
    allOptionses(filter: { doctor: { id: $doctorId } }) {
      baseDuration
      minTimeAdmin
      maxTimeAdmin
    }
  }
`;
// graphql(ALL_SLOTTYPES_QUERY, { name: "allSlotTypesQuery" })

export default compose(
  graphql(GET_DAYTEMPLATE_QUERY, {
    name: "getDayTemplate",
    options: ({ templateId }) => ({
      variables: { templateId },
      fetchPolicy: "network-only"
    })
  }),
  graphql(GET_DOCTOR_OPTIONS_QUERY, {
    name: "getDoctorOptionsQuery",
    options: ({ doctorId }) => ({
      variables: { doctorId },
      fetchPolicy: "network-only"
    })
  }),
  graphql(ALL_SLOTTYPES_QUERY, {
    name: "allSlotTypesQuery",
    options: ({ doctorId }) => ({ variables: { doctorId } })
  })
)(EditTemplate);



// WEBPACK FOOTER //
// ./src/components/utilities/EditTemplate.js